import React, { useEffect } from 'react'
import Navbar from '../../Components/Navbar'
import { useSelector } from 'react-redux';
import { useNavigationHook } from '../../Hooks/useNavigationHook';
import QnaSelector from './components/QnaSelector';
import { useQnaHook } from './useQnaHook';

export default function Qna() {
    const { returnSelectedQnaPage } = useQnaHook();
    const {
        accessToken,
        refreshToken,
        UID,
    } = useSelector((state: any) => state.auth.value);
    const {
        navigateTo
    } = useNavigationHook();

    const checkAuth = () => {
        if (accessToken === '' || refreshToken === '' || UID === '') {
            navigateTo('/');
        };
    };

    useEffect(() => {
        checkAuth();
    }, []);

    return (
        <div className='flex justify-center items-center flex-col'>
            <Navbar />
            <QnaSelector />
            {returnSelectedQnaPage()}
        </div>
    )
}
